import Title from "./Title";
import Details from "./Details";

const Container = ({ children, namePage, icon }) => {
  return (
    <section className="w-full">
      <Title namePage={namePage} icon={icon} />
      <Details />
      <h2 className="text-xl font-bold">Case Update</h2>
      <p className="text-sm">
        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Aspernatur
        provident magni beatae esse! Tenetur, voluptates optio qui tempora in
        impedit dolorem at reiciendis fuga cupiditate praesentium itaque, odio
        enim. Sed?
      </p>
      <article className="flex flex-wrap gap-4 mt-6">{children}</article>
    </section>
  );
};

export default Container;
